import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNullable from "../Data.Nullable/index.js";
import * as Effect$dException from "../Effect.Exception/index.js";
import * as Effect$dTimer from "../Effect.Timer/index.js";
import * as Web$dDOM$dNode from "../Web.DOM.Node/index.js";
import * as Web$dDOM$dNodeList from "../Web.DOM.NodeList/index.js";
import * as Web$dDOM$dParentNode from "../Web.DOM.ParentNode/index.js";
import * as Web$dEvent$dEventTarget from "../Web.Event.EventTarget/index.js";
import * as Web$dHTML from "../Web.HTML/index.js";
import * as Web$dHTML$dHTMLDocument from "../Web.HTML.HTMLDocument/index.js";
import * as Web$dHTML$dWindow from "../Web.HTML.Window/index.js";
import * as Web$dInternal$dFFI from "../Web.Internal.FFI/index.js";
import {
  addClass,
  addTestLoadedMarker,
  closestImpl,
  focus,
  getData,
  getValue,
  hasClass,
  logErrorOnElement,
  parents,
  queueMicrotask,
  removeClass,
  setData,
  setInnerHtml,
  setInnerText
} from "./foreign.js";
const show = /* #__PURE__ */ removeClass("hide");
const removeChildren = /* #__PURE__ */ setInnerHtml("");
const querySelectorAll$p = selector => element => {
  const $0 = Web$dDOM$dParentNode.querySelectorAll(selector)(element);
  const $1 = Data$dFunctor.arrayMap(Web$dInternal$dFFI.unsafeReadProtoTagged("Element"));
  return () => {
    const $2 = $0();
    const a$p = Web$dDOM$dNodeList.toArray($2)();
    return Data$dArray.mapMaybe(x => x)($1(a$p));
  };
};
const querySelector$p = selector => element => Web$dDOM$dParentNode.querySelector(selector)(element);
const querySelectorOrThrow = selector => element => {
  const $0 = Web$dDOM$dParentNode.querySelector(selector)(element);
  return () => {
    const maybeElement = $0();
    if (maybeElement.tag === "Just") { return maybeElement._1; }
    if (maybeElement.tag === "Nothing") { return Effect$dException.throwException(Effect$dException.error("Couldn't select " + selector))(); }
    $runtime.fail();
  };
};
const parentNode$p = node => {
  const $0 = Web$dDOM$dNode._parentNode(node);
  return () => {
    const a$p = $0();
    const maybeParent = Data$dNullable.nullable(a$p, Data$dMaybe.Nothing, Data$dMaybe.Just);
    const maybeNode = (() => {
      if (maybeParent.tag === "Just") { return Web$dInternal$dFFI._unsafeReadProtoTagged(Data$dMaybe.Nothing, Data$dMaybe.Just, "Element", maybeParent._1); }
      if (maybeParent.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    })();
    if (maybeNode.tag === "Nothing") { return Effect$dException.throwException(Effect$dException.error("Parent not found"))(); }
    if (maybeNode.tag === "Just") { return maybeNode._1; }
    $runtime.fail();
  };
};
const hide = /* #__PURE__ */ addClass("hide");
const globalQuerySelectorAll = selector => () => {
  const $0 = Web$dHTML.window();
  const doc = Web$dHTML$dWindow.document($0)();
  const $1 = Web$dDOM$dParentNode.querySelectorAll(selector)(doc)();
  const a$p = Web$dDOM$dNodeList.toArray($1)();
  return Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(Web$dInternal$dFFI.unsafeReadProtoTagged("Element"))(a$p));
};
const globalQuerySelector = selector => () => {
  const $0 = Web$dHTML.window();
  const doc = Web$dHTML$dWindow.document($0)();
  return Web$dDOM$dParentNode.querySelector(selector)(doc)();
};
const ensureExistance = errorMsg => maybeEl => {
  if (maybeEl.tag === "Nothing") { return Effect$dException.throwException(Effect$dException.error(errorMsg)); }
  if (maybeEl.tag === "Just") {
    const $0 = maybeEl._1;
    return () => $0;
  }
  $runtime.fail();
};
const closest = /* #__PURE__ */ closestImpl(Data$dMaybe.Just)(Data$dMaybe.Nothing);
const appendChild$p = child => root => Web$dDOM$dNode.appendChild(child)(root);
const addEventListenerImpl = eventType => eventListener => eventTarget => Web$dEvent$dEventTarget.addEventListener(eventType)(eventListener)(true)(eventTarget);
const executeWhenLoaded = listenerFunction => () => {
  const win = Web$dHTML.window();
  const doc = Web$dHTML$dWindow.document(win)();
  const state = Web$dHTML$dHTMLDocument.readyState(doc)();
  const listener = Web$dEvent$dEventTarget.eventListener(v => listenerFunction)();
  if (state.tag === "Loading") { return Web$dEvent$dEventTarget.addEventListener("DOMContentLoaded")(listener)(true)(doc)(); }
  Effect$dTimer.setTimeoutImpl(0)(listenerFunction)();
};
const addEventListener$p = eventType => listener => element => Web$dEvent$dEventTarget.addEventListener(eventType)(listener)(true)(element);
export {
  addEventListener$p,
  addEventListenerImpl,
  appendChild$p,
  closest,
  ensureExistance,
  executeWhenLoaded,
  globalQuerySelector,
  globalQuerySelectorAll,
  hide,
  parentNode$p,
  querySelector$p,
  querySelectorAll$p,
  querySelectorOrThrow,
  removeChildren,
  show
};
export * from "./foreign.js";
